import * as t from 'io-ts';

const DashboardFlagsT = {
  show_onboarding: t.boolean,
  show_appsumo_onboarding: t.boolean,
};

export const DashboardFlagsV = t.type(DashboardFlagsT);
export const DashboardFlagsPartialV = t.partial(DashboardFlagsT);
